<ng-container *transloco="let t; read: 'shareButton'">
  <button
    [data]="data"
    type="button"
    mat-button
    color="primary"
    data-id="share-button"
    aria-label="share"
    rmaShare
    [title]="t('button-text')"
    class="flex items-center">
    <rma-icon [glyph]="icon" />

    @if (buttonType !== 'icon') {
      <span [ngClass]="buttonType !== 'responsive' ? { hidden: true, 'md:inline-flex': true } : {}">{{ t('button-text') }}</span>
    }
  </button>
</ng-container>
